


var isDesktop=false;
var isMobile=false;
var isSmartPhone=false;





$(document).ready(function(){
  if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    addAccordion();
    enableAccordion();
  }
  // setImgheight();
  initSite();

});



function initSite(){

	bindEvents();

}



function bindEvents(){
    deviceCheck();
    //manageScroll();
    prepareSliders();
    //buildSlider();
    //toggleMenue();
    // setTimeout (swWrap, 600);
    //swWrap();
    // setPins();

    // setMbHeroHeight();
    //getJobInfoList();
    chckScrollMenu();
    $('.toTopWrapper').click(pageToTop);
    showToTop();

    $(window).scroll(function() {
        chckScrollMenu();
        showToTop();
    });
    $(window).resize(function() {
        // $('.innerVideo').each(function (index, value) {
        //     var mediaVideo = $(this).get(0);
        //     mediaVideo.pause();
        //
        // });

            clearTimeout(window.resizedFinished);
        // if ($('.burger').hasClass('is-active')) {
        // //toggleMenue();
        // }
        // window.resizedFinished = setTimeout(function () {
        //     // setMbHeroHeight();
        // }, 100);
        window.resizedFinished = setTimeout(function () {
            resizeEnd();
            deviceCheck();
            chckScrollMenu();
            // setPins();
            // prepareSliders();
            // setImgheight();
            setImageMap();
            //equalHeight();
        }, 500);

    });
    $('.vi-uf-menueMain').click(function(){
      toggleMenue();
      animateBurger();
    });

/*
    $('.sliderMask').click(function(){
        _sliderId = $(this).parent(),find('vi-uf-sliderBox').atr('id');
        $('#'+ _sliderId).iosSlider('autoSlidePlay');
        $(element).iosSlider('autoSlidePause');
    });
*/


    $('.valCheck').bind('input', function() {
        validateTextField( $(this).attr('id'), $(this).val() );
    });
    /*$('.valCheck').bind('textarea', function() {
        validateTextField( $(this).attr('id'), $(this).val() );
    });*/
    $('.valCheck').bind('change', function() {
        validateTextField( $(this).attr('id'), $(this).val() );
    });


    renewEvents();


    manageScroll();
    // initGCS();

    setYoutubeBox();
    setMbAccordion();
    setImageMap();
    cleanJobDisplay();
    // enableTabs();
    $(window).on('hashchange', function() {
        manageScroll();
    });
    setTimeout (displayConfirm, 600);
    setTimeout (enableTabs, 1000);

/*
    setTimeout(function () {
        $('#gsc-i-id1').attr('placeholder', 'Suchbegriff eingben');
        console.log('done');
        }, 800);
*/

}



function renewEvents(){
    $('.burgerMenueContainer').on('mouseover', function(event){
        if(isDesktop) {
            $(".burgerMenue").toggleClass("active");
            $(".wrapperLowerPart").toggleClass("openMenue");
            $("#header, .allContent").addClass('headerBig');
        }
    });


    $('.burgerMenueContainer').on('click', function(event){
        if(!isDesktop) {
            $(".burgerMenue").toggleClass("active");
            $(".wrapperLowerPart").toggleClass("openMenue");
            $('.wrapperLowerPart').css({'height': ''});
            // // $("#header, .allContent").addClass('headerBig');
            // $(this).off('onmousover').on('mouseout', function(event){
            //     console.log('mouseout');
            //     renewEvents();
            // });
        }

    });


}


function resizeEnd(){
    $('.vi-uf-sliderBox').each(function (index, value) {
        sliderId = '#' + $(this).attr('id');
        $(sliderId).iosSlider('destroy');
    });

    prepareSliders();


}




function sizeSlider(){
    //return

    $(".sliderWrapper").each(function(index, element) {
        setTimeout (updateSlider, 600, $( this ));
    })

}

function updateSlider( _slider ){
    $('#'+$(_slider).attr('id')).iosSlider('update');
}


function chckScrollMenu(){
    var slimit=100;
    var bScroll=Number($("body").scrollTop());
    var hScroll=Number($("html").scrollTop());
    if((hScroll>slimit || bScroll>slimit) && $("#header").hasClass('headerBig')){
        $("#header, .allContent").removeClass('headerBig');
    }
    if($('.burgerMenueContainer').isHidden){
        $(".burgerMenue").removeClass("active");
        $(".wrapperLowerPart").removeClass("openMenue");
    }
    if(isDesktop) {
        $(".burgerMenue").removeClass("active");
        $(".wrapperLowerPart").removeClass("openMenue");
    }
    if(!isDesktop){
        // $('.wrapperLowerPart').css({'height':''});
        // $(".wrapperLowerPart").removeClass("openMenue");

        // $('.vi-uf-menueBoxInner').each(function() {
        //     if(!$(this).css('display')=='none'){
        //         $(this).css({'display':''});
        //
        //     }
        // });
        // $('.headTop, .searchBox').off('mouseover');
        // $('.wrapperLowerPart').off('mouseleave');

    }
    //
    if((hScroll<slimit && bScroll<slimit) && !$("#header").is('headerBig'))
        $("#header, .allContent").addClass('headerBig');

}



function pageToTop(){
    $("html,body").animate({scrollTop:0}, '500');
}

function showToTop(){
    var slimit=100;
    var bScroll=Number($("body").scrollTop());
    var hScroll=Number($("html").scrollTop());
    if((hScroll>slimit || bScroll>slimit) && $(".toTopWrapper").is(':hidden'))
        $(".toTopWrapper").fadeIn(500);

    if((hScroll<slimit && bScroll<slimit) && $(".toTopWrapper").is(':visible'))
        $(".toTopWrapper").hide();


    // if($('.bc-159').length>0){
    if(!isDesktop && $('.bc-189').length>0 && !$('.openMenue').length>0){
    // if(!isDesktop && $('.bc-159').length>0 && !$('.openMenue').length>0){
        var lplimit=70;
        if((hScroll>lplimit || bScroll>lplimit) && $("#header").is(':visible'))
        $("#header").hide();

        if((hScroll<lplimit && bScroll<lplimit) && $("#header").is(':hidden'))
        $("#header").fadeIn(500);

    }

}


function deviceCheck(){
    if(navigator.userAgent.indexOf('AppleWebKit') != -1){
        // add position:relative to body
        $("body").css('position','relative');
    }
    var helper=parseInt($("body").css('z-index'));
    isDesktop=isTablet=isSmartPhone=false;
    switch(helper){
        case 1:
            isDesktop=true;
            break;
        case 2:
            isMobile=true;
            break;
        case 3:
            isSmartPhone=true;
            break;
    }
    return helper;
}




function toggleMenue(){
    if ( $('.burger').hasClass('is-active')){
        $('.burger').removeClass('is-active');
        $('#header').removeClass('headerMobileBG');
    }else{
        $('.burger').addClass('is-active');
        $('#header').addClass('headerMobileBG');
    }
    //$('.headerMenue ul').toggle();
    $('.headerMenue').toggleClass('mobileMenue');
}



/*
function swWrap(){
    $('.swWrap').BlackAndWhite({
        hoverEffect : true, // default true
        // set the path to BnWWorker.js for a superfast implementation
        webworkerPath : false,
        // to invert the hover effect
        invertHoverEffect: false,
        // this option works only on the modern browsers ( on IE lower than 9 it remains always 1)
        intensity:1,
        speed: { //this property could also be just speed: value for both fadeIn and fadeOut
            fadeIn: 200, // 200ms for fadeIn animations
            fadeOut: 600 // 800ms for fadeOut animations
        },
        onImageReady:function(img) {
            // this callback gets executed anytime an image is converted
        }
    });

}
*/


function manageScroll(){
    tempHash = window.location.hash;
    if(tempHash!=undefined&&tempHash!=''&&tempHash!=null&&tempHash!=0){
        tempPosition = $(tempHash).offset().top;
        newPosition = tempPosition-125;
        $('html, body').animate({
            scrollTop:newPosition
        },'slow');

    }

}

function equalHeight(){
    if(isSmartPhone!=true){
        var addedClasses="";
        var addedClassesCol="";
        if(arguments[0]!=undefined) addedClasses=arguments[0];
        if(arguments[1]!=undefined) addedClassesCol=arguments[1];

        if($('.sameHeightRow'+addedClasses).length<=0) return;

        $('.sameHeightRow'+addedClasses+' .sameHeightCol .mbInnerBox'+addedClassesCol).css("height", "auto");
        $('.multiBox'+addedClassesCol+' .sameHeightRow .mbInnerBox').css("height", "auto");

        setTimeout(function(){
            $('.sameHeightRow'+addedClasses).each(function(){
                var highestBox = 0;
                $('.sameHeightCol .mbInnerBox'+addedClassesCol, this).each(function(){
                    if($(this).height() > highestBox) {
                        highestBox = $(this).height();
                    }
                });
                $('.sameHeightCol .mbInnerBox'+addedClassesCol,this).height(highestBox);
                $('.sameHeightCol .companyBox'+addedClassesCol, this).each(function(){
                    if($(this).height() > highestBox) {
                        highestBox = $(this).height();
                    }
                });
                $('.sameHeightCol .companyBox'+addedClassesCol,this).height(highestBox);
            });
            $('.themenCont').each(function(){
                var highestBox = 0;
                $('.themBox', this).each(function(){
                    if($(this).height() > highestBox) {
                        highestBox = $(this).height();
                    }
                });
                $('.themBox',this).height(highestBox);
            });
        }, 10);
    }
}


function setMbHeroHeight() {
    $('.vi-uf-mbHero').each(function () {
        // $(this).find('.heightPH').show();
            var tempHeight = $(this).find('.heightPH').first().innerHeight();
            var tempTitleHeight = $(this).find('.boxTitle').first().innerHeight() +120;
            if(tempHeight<tempTitleHeight){
                $(this).find('.heightPH').hide();
                $(this).height(tempTitleHeight);
            }else {
                $(this).find('.heightPH').show();
                $(this).height(tempHeight);
            }
    });

}



function getHtmlContent(mapHandlerURL, ajaxCallback){

    var trgAdress = mapHandlerURL;
    $.ajax({
        type: 'get',
        context: document,
        // cache: false,
        url: trgAdress
    })
        .done(function(data) {
            try{
                var response;
                response = data.trim();
                queryActionHandler_retVal = response;

                if(ajaxCallback != undefined) ajaxCallback.call();
                return(response);

            }catch(err){
                alert("Fehler: " + err);
            }
        })
        .fail(function(err) {
            alert("Es ist ein Fehler aufgetreten: " + err);
        });

}



function setYoutubeBox(){
/*
    $('.vi-uf-blogListItem .vi-uf-blogBox').each(function(){
        if($('.vi-uf-blogBoxVideo', this).length > 0){
            var srcVal = $('.vi-uf-blogBoxVideo', this).data('src-value');
            if(srcVal.indexOf('youtu.be')!= -1){
                var ytSrcFind = srcVal.lastIndexOf('/');
                var ytSrcClean = srcVal.slice(ytSrcFind);
            }else{
                var ytSrcFind = srcVal.lastIndexOf('=') + 1;
                var ytSrcClean = '/' + srcVal.slice(ytSrcFind);
            }
            $('.vi-uf-blogBoxImage', this).hide();
            $('.vi-uf-blogBoxVideo', this).show().find('iframe').attr('src','https://www.youtube.com/embed'+ytSrcClean+'?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0');  //.attr('autoplay','1').get(0).click();
        }
    });
*/
    $('.vi-uf-multiBoxInnerContent').each(function(){
        if($('.videoLinkEl', this).length > 0){
            var srcVal = $('.videoLinkEl', this).data('src-value');
            if(srcVal.indexOf('youtu.be')!= -1){
                var ytSrcFind = srcVal.lastIndexOf('/');
            }else{
                var ytSrcFind = srcVal.lastIndexOf('=');
            }
            var ytSrcClean = srcVal.slice(ytSrcFind);
            $('.videoLinkEl', this).find('iframe').attr('src','https://www.youtube.com/embed'+ytSrcClean+'?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0');  //.attr('autoplay','1').get(0).click();
        }
    });
}


function openDialog(){
    $('#dialogContainer').toggle();
}


function removeOverlay(_el){
    $(_el).hide().parent().find('video').get(0).play();
}




function enableTabs() {

}


function setMbAccordion(){
        $( ".vi-uf-mbAccordion" ).accordion({
            header: ".boxTitle",
            content: ".boxBody",
            active: false,
            collapsible: true,
            animate: 200

        });


    $( ".vi-uf-mbAccordion.openAccordion" ).accordion( "option", "active", 0 );
}


function openTab(_id, _elem) {
    $(_elem).parent().find('.tabHead').removeClass('active');
    $(_elem).addClass('active');
    $(_elem).parent().parent().find('.tabContainer').removeClass('active');
    $('#'+_id).addClass('active');
}

var scrollProcess = false;


function setImageMap(){
    scrollProcess = false;
    $('.mapArea').each(function(){
       var imageHeight = $(this).parent().find('img').height();
       var rel = imageHeight / 100;
       var imageRel = 2.16;
       $('.singleArea',this).each(function(){
          var x1 = $(this).data('value-x1');
          var y1 = $(this).data('value-y1');
          var x2 = $(this).data('value-x2');
          var y2 = $(this).data('value-y2');
          var x1Rel = x1 * rel;
          var y1Rel = y1 * rel;
          var x2Rel = x2 * rel;
          var y2Rel = y2 * rel;
          var coord = '"'+x1Rel+','+y1Rel+','+x2Rel+','+y2Rel+'"';
          $(this).prop('coords',coord);
       });
    });
}


function clickTabId(_id) {
    if(!scrollProcess) {
        $('#' + _id).click();
    }
}



function goToId(_id){
    scrollProcess = true;
    var offSet = $('#header').innerHeight();

    scrollToY( $('#'+_id).offset().top - (offSet + 50)) ;

    setTimeout(function(){
        scrollProcess = false;
    },200);


}
